export default [
  {
    name: 'managementConsole',
    path: '/',
    icon: 'dashboard',
  },
  {
    name: 'projects',
    path: '/projects',
    icon: 'projects',
    // 开启时不使用本地的语言库
    isI18n: true,
    children: [
    ],
  },
  {
    name: 'monitoringData',
    path: '/monitor',
    icon: 'charts',
    dfOpen: true,
    children: [
      {
        name: 'commonMonitor',
        path: '/monitor/index',
        icon: 'monitor1',
      },
      { // 组合监测 隐藏
        name: 'groupMonitor',
        path: '/monitor/group',
        icon: 'monitor2',
      },
    ],
  },
  {
    name: 'alarmRecord',
    path: '/alerts',
    icon: 'alert',
    meta: {
      permissions: ['View:Alert'],
    },
  },
  {
    name: 'reports',
    path: '/reports',
    icon: 'table',
    meta: {
      permissions: ['View:Report'],
    },
    children: [
      {
        name: 'exportReport',
        path: '/reports/export',
        icon: 'export',
      },
      {
        name: 'downloadReport',
        path: '/reports/download',
        icon: 'download',
      },
    ],
  },
  {
    name: 'deviceConsole',
    path: '/console/devices',
    icon: 'device-list',
    meta: {
      permissions: ['View:Device'],
    },
  },
  {
    name: 'projectConsole',
    path: '/console/projects',
    icon: 'projects2',
    meta: {
      permissions: ['View:Project'],
    },
  },
  {
    name: 'systemManagement',
    path: '/console/index',
    icon: 'setting',
    super: true,
    children: [
      {
        name: 'corporateInformation',
        path: '/console/corporation',
        icon: 'corporation',
        meta: {
          permissions: ['View:Corporation'],
        },
      },
      {
        name: 'contacts',
        path: '/console/contacts',
        icon: 'avatar',
        meta: {
          permissions: ['Update:Corporation'],
        },
      },
      {
        name: 'config',
        path: '/console/config',
        icon: 'table',
        meta: {
          permissions: ['Update:Corporation'],
        },
      },
      {
        name: 'accountManagement',
        path: '/console/users',
        icon: 'user',
        meta: {
          permissions: ['View:User'],
        },
      },
      {
        name: 'rolePermissions',
        path: '/console/roles',
        icon: 'role',
        meta: {
          permissions: ['View:Role'],
        },
      },
      {
        name: 'groupManagement',
        path: '/console/user-groups',
        icon: 'user-group',
        meta: {
          permissions: ['View:UserGroup'],
        },
      },
      // {
      //   name: 'pushStrategy',
      //   path: '/console/pushStrategy',
      //   icon: 'pushStrategy',
      //   meta: {
      //     permissions: ['Create:PushRule', 'Delete:PushRule', 'Update:PushRule'],
      //   },
      // },
      {
        name: 'operationLog',
        path: '/console/operationLog',
        icon: 'message',
        meta: {
          permissions: ['View:OperationLog'],
        },
      },
      // {
      //   name: 'ps',
      //   path: '/console/ps',
      //   icon: 'contacts',
      //   meta: {
      //     permissions: ['View:Corporation'],
      //   },
      // },
    ],
  },
];
